import { HttpClient } from '@angular/common/http';
import { Injectable, TransferState } from '@angular/core';
import { HttpLink } from 'apollo-angular/http';

import { Apollo } from 'apollo-angular';
import { BaseGQLService } from 'src/app/core/services/base-gql.service';
import { environment } from 'src/environments/environment';



@Injectable({
  providedIn: 'root'
})
export class WritersContentService extends BaseGQLService<any> {
  constructor(
    protected override httpLink: HttpLink,
    public override apollo: Apollo,
    protected override transferState: TransferState,
    private http: HttpClient
  ) {
    super(
      {
        typeId: '',
        model: WritersContentModel,
        clientName: 'WritersContentService',
        url: `${environment.serverUrl}/api/content/acer/graphql`,
        rootTypeName: 'queryWritersContents',
        disableCache: true,
      },
      httpLink,
      apollo,
      transferState
    );
  }



}

export class WritersContentModel{
  id:string = '';
  flatData:WritersContentDetails = new WritersContentDetails();
}

export class WritersContentDetails{
  writername:string = '';

}